import React from "react";
import styles from "./ServiceHistoryRisksSection.module.css";

const ServiceHistoryRisksSection = () => {
  const riskCards = [
    { percentage: "40%", id: 1, label: "Unexpected Repair Costs", description: "Unaddressed issues can lead to major repairs, increasing expenses." },
    { percentage: "30%", id: 2, label: "Reduced Vaahan Lifespan", description: "Neglecting maintenance shortens your vaahan's operational life." },
    { percentage: "40%", id: 3, label: "Safety Hazards", description: "Undetected faults may compromise vaahan safety on the road." },
    { percentage: "40%", id: 4, label: "Lower Resale Value", description: "Incomplete service records can reduce your vaahan's market worth." },
    { percentage: "30%", id: 5, label: "Legal Non-Compliance", description: "Missed RTO requirements can lead to fines or legal issues." },
    { percentage: "40%", id: 6, label: "Poor Performance", description: "Lack of maintenance affects fuel efficiency and driving experience." },
    { percentage: "40%", id: 7, label: "Insurance Complications", description: "Incomplete records may complicate insurance claims." },
    { percentage: "30%", id: 8, label: "Breakdown Risks", description: "Unserviced vehicles are prone to unexpected breakdowns." },
    { percentage: "40%", id: 9, label: "Environmental Impact", description: "Poor maintenance increases emissions, harming the environment." }
  ];

  return (
    <div className={styles.sectionContainer}>
      <h2 className={styles.sectionTitle}>Risks of Not Checking Vaahan Service History</h2>
      <p className={styles.sectionDescription}>
        Skipping regular vaahan service history checks can lead to costly consequences. From unexpected repairs to legal issues, here are the risks you face:
      </p>

      <div className={styles.cardsContainer}>
        {riskCards.map((card) => (
          <div key={card.id} className={styles.riskCard}>
            <div className={styles.cardImage}></div>
            <div className={styles.cardLabel}>
              <p>{card.label}</p>
            </div>
            <div className={styles.cardContent}>
              <p className={styles.percentageText}>Up to {card.percentage}</p>
              <p className={styles.smallText}>{card.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h2 className={styles.whyChooseTitle}>Why Choose VAAHANBUDDY</h2>

      <div className={styles.testimonialContainer}>
        {[
          { id: 1, name: "Amit Sharma", text: "VAAHANBUDDY made my vaahan registration process so easy! The doorstep service saved me hours of waiting at the RTO office." },
          { id: 2, name: "Priya Patel", text: "I got my driving license renewed without any hassle. The team was professional and prompt!" },
          { id: 3, name: "Rahul Verma", text: "Their service history checks helped me avoid buying a faulty used car. Highly recommend!" },
          { id: 4, name: "Sneha Gupta", text: "VAAHANBUDDY handled my vaahan transfer paperwork seamlessly. No stress, no delays!" },
          { id: 5, name: "Vikram Singh", text: "The doorstep RTO services are a game-changer. Fast, reliable, and convenient!" },
          { id: 6, name: "Anjali Desai", text: "Thanks to VAAHANBUDDY, my insurance renewal and RTO compliance were sorted in no time!" }
        ].map((item) => (
          <div key={item.id} className={styles.testimonialCard}>
            <div className={styles.userInfo}>
              <div className={styles.userAvatar}></div>
              <p className={styles.userName}>{item.name}</p>
            </div>
            <div className={styles.starsContainer}>
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star} className={styles.star}>★</span>
              ))}
            </div>
            <p className={styles.testimonialText}>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceHistoryRisksSection;